import { inject } from '@angular/core';
import { type CanMatchFn, Router } from '@angular/router';

import { environment } from '@env';

import { AppPath } from '@kernel';

export const devGuard: CanMatchFn = () => {
  if (!environment.production) return true;

  return inject(Router).createUrlTree([AppPath.Login]);
};
